import {AuthenticatedTemplate, useMsal} from "@azure/msal-react";
import {Navigate} from "react-router-dom";
import {loginRequest} from "../../../authConfig";
import {ToastContainer} from "react-toastify";
import React from "react";
import './LoginPage.scss';

const Login = () => {
    const {instance} = useMsal();
    const loginHandler = () => {
        instance.loginRedirect(loginRequest).catch((e) => {
            console.error(e);
        });
    };
    return (
        <>
            <AuthenticatedTemplate>
                <Navigate to="/"/>
            </AuthenticatedTemplate>
            <div className="login-page">
                <div className="login-menu">
                    <img src="./assets/images/grape_logo.svg" alt="logo" className="top-logo"/>
                    <img src="./assets/images/grejpapu.svg" alt="logo-grejpapu" className="login-menu__application-name"/>
                    <button className="default-button" onClick={loginHandler}>
                        Sign in using SSO
                    </button>
                </div>
                <ToastContainer autoClose={7000}/>
            </div>
            );
        </>
    );
};


export default Login;
